/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * UserAddDTO.ts
 */

import {Type} from "../../../tools/view/form/FormInput";
import Translation from "../../../services/translation/Translation";
import {TextField} from "../../../tools/model/form/TextField";
import {AbstractForm} from "../../../tools/model/form/AbstractForm";
import {Field} from "../../../tools/model/form/Field";
import User from "../../User";
import {UserEditIdentityDTO} from "../../dto/user/UserEditIdentityDTO";
import {CheckboxField} from "../../../tools/model/form/CheckboxField";

export default class AdminUserEditIdentityForm extends AbstractForm<UserEditIdentityDTO> {
    fields: Map<string, Field<any>> = new Map<string, Field<any>>();

    constructor(user: User) {
        super();

        this.fields.set(UserEditIdentityDTO.FIRSTNAME, new TextField(
            UserEditIdentityDTO.FIRSTNAME,
            (t: Translation) => t.userListColFirstName,
            value => value.toString().length !== 0,
            Type.TEXT,
            true,
            "",
            ""
        ));

        this.fields.set(UserEditIdentityDTO.LASTNAME, new TextField(
            UserEditIdentityDTO.LASTNAME,
            (t: Translation) => t.userListColLastName,
            value => value.toString().length !== 0,
            Type.TEXT,
            true,
            "",
            ""
        ));

        this.fields.set(UserEditIdentityDTO.PHONE, new TextField(
            UserEditIdentityDTO.PHONE,
            (t: Translation) => t.userListColPhone,
            value => value.toString().length >= 10,
            Type.TELEPHONE,
            true,
            "",
            ""
        ));

        this.fields.set(UserEditIdentityDTO.HAS_MULTIPLE_CONNECTIONS, new CheckboxField(
            UserEditIdentityDTO.HAS_MULTIPLE_CONNECTIONS,
            (t: Translation) => t.userListColMultipleConnection,
            () => true,
            Type.CHECKBOX,
            false,
            user.has_multiple_connections,
            false
        ));

        this.load(UserEditIdentityDTO.fromUser(user));
    }
}
